export default __webpack_public_path__ + "static/media/copy-solid-blue.372ee997.svg";